import MenuItem, { type MenuItemProps } from '@mui/material/MenuItem';
import type { SxProps, Theme } from '@mui/material/styles';

import { mergeSx } from '@/utils/mergeSx';

import { headerMenuItemStyles as sx } from './HeaderMenuItem.styles';

interface Props extends Omit<MenuItemProps, 'sx'> {
	customSx?: SxProps<Theme>;
}

export const HeaderMenuItem = ({ customSx, children, ...props }: Props) => (
	<MenuItem sx={mergeSx(sx.root, customSx)} {...props}>
		{children}
	</MenuItem>
);
